import { gql } from "@apollo/client";

export const ADMIN_HERO_SECTION_QUERY = gql`
  query AdminHeroSection {
    adminHeroSection {
      id
      heading
      subheading
      description
      leftImage
      rightImage
      updatedAt
    }
  }
`;

export const UPSERT_HERO_SECTION_MUTATION = gql`
  mutation UpsertHeroSection(
    $heading: String
    $subheading: String
    $description: String
    $leftImage: String
    $rightImage: String
  ) {
    adminUpsertHeroSection(
      input: {
        heading: $heading
        subheading: $subheading
        description: $description
        leftImage: $leftImage
        rightImage: $rightImage
      }
    ) {
      heroSection {
        id
        heading
        subheading
        description
        leftImage
        rightImage
        updatedAt
      }
      errors
    }
  }
`;

export const HERO_SECTION_QUERY = gql`
  query HeroSection {
    heroSection {
      heading
      subheading
      description
      leftImage
      rightImage
    }
  }
`;
